<div class="payment-form-holder" [ngSwitch]="selectedTypeOfPayment">
    <div class="accepted-payments-holder">
        <ul *ngIf="paymentsConfig && paymentsConfig.brand_logo_urls">
            <li *ngIf="paymentsConfig && paymentsConfig.supported_brands_title" class="accepted-payments-title">
                <span>{{ paymentsConfig.supported_brands_title }}</span>
            </li>
            <li 
                *ngIf="!paymethodSetup?.payload?.unsupported_brands?.includes('visa')"
                class="card"
                [ngStyle]="{'background': 'url(' + paymentsConfig.brand_logo_urls.visa + ') no-repeat', 'background-size': '100%'}">
            </li>
            <li
                *ngIf="!paymethodSetup?.payload?.unsupported_brands?.includes('master')"
                class="card"
                [ngStyle]="{'background': 'url(' + paymentsConfig.brand_logo_urls.mastercard + ') no-repeat', 'background-size': '100%'}">
            </li>
            <li
                *ngIf="!paymethodSetup?.payload?.unsupported_brands?.includes('maestro')"
                class="card"
                [ngStyle]="{'background': 'url(' + paymentsConfig.brand_logo_urls.maestro + ') no-repeat', 'background-size': '100%'}">
            </li>
            <li
                *ngIf="!paymethodSetup?.payload?.unsupported_brands?.includes('amex')"
                class="card"
                [ngStyle]="{'background': 'url(' + paymentsConfig.brand_logo_urls.amex + ') no-repeat', 'background-size': '100%'}">
            </li>
        </ul>
    </div>
    <div *ngSwitchCase="'Stripe'">
        <serviceos-web-stripe
            [paymethodSetup]="paymethodSetup"
        ></serviceos-web-stripe>
    </div>
    <div *ngSwitchCase="'Braintree'">
        <serviceos-web-braintree
            [paymethodSetup]="paymethodSetup"
        ></serviceos-web-braintree>
    </div>
    <div *ngSwitchDefault></div>
    <div class="certificate-box">
        <div class="sos-text-holder">
            <div class="lock-box">
                <span
                    *ngIf="paymentsConfig && paymentsConfig.certificate_widget && paymentsConfig.certificate_widget.title"
                    class="sos-title">{{ paymentsConfig.certificate_widget.title }}</span>
                <span 
                    *ngIf="paymentsConfig && paymentsConfig.certificate_widget && paymentsConfig.certificate_widget.subtitle"
                    class="subtitle">{{ paymentsConfig.certificate_widget.subtitle }}</span>
            </div>    
        </div>
        <div
            *ngIf="paymentsConfig && paymentsConfig.certificate_widget && paymentsConfig.certificate_widget.link"    
            class="badge-holder">
            <a [href]="paymentsConfig.certificate_widget.link.href" target="_blank" rel="noopener noreferrer">
                <img [src]="paymentsConfig.certificate_widget.link.image_url" alt="SecurityMetrics Credit Card Safe" />
            </a>
        </div>
    </div>
</div>